<template>
  <div>
    <div class="container-fluid" style="height: 65px">
      
      <div class="row">
        <div class="col">
          <div class="form-group">
            <input
              class="form-control personalise"
              placeholder="Numéro facture..."
              type="text"
              v-model="search"
            />
          </div>
        </div>
      </div>

      <router-link :to="`/facture/${search}`">
        <CButton
          style="
            margin-bottom: -25px;
            border-radius: 15px 18px;
            margin-top: -18px;
            margin-left: -8px;
          "
          color="info"
          class="mr-1 cl"
        >
          Rechercher
        </CButton>
      </router-link>
    </div>
  </div>
</template>


<script>
import { apiDomain } from "../../config";
import axios from "axios";
import HighlightWords from "vue-highlight-words";

import Highlighter from "vue-highlight-words";
export default {
  props: {
    tableHeaderColor: {
      type: String,
      default: "",
    },
  },
  components: {
    Highlighter,
    HighlightWords,
  },
  data() {
    return {
      search: "",
     
    };
  },



 

  
};
</script>

<style>
.feed {
  background: #fff;
  height: 106px;
  overflow: scroll;
}
.btdelete {
  padding: 11px 27px !important;
  margin-top: 38px;
  border-radius: 5px;
}
/* 
.md-card img {
  width: 55% !important;
  height: auto;
} */
</style>

